/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import moveEntityTemplate from '../admin/entity/move-entity.tpl.html';
import copyEntityTemplate from '../admin/entity/copy-entity.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

import MoveEntityController from '../admin/entity/move-entity.controller';
import CopyEntityController from '../admin/entity/copy-entity.controller';

export default angular.module('agrolog.api.weatherStation', [])
    .factory('weatherStationService', WeatherStationService)
    .name;

/*@ngInject*/
function WeatherStationService($q, $mdDialog, $document, types, agTypes, agUserService, entityService, entityRelationService) {

    var allWeatherStationAttributesKeys = [];

    for (var attrId in agTypes.attributes.baseAsset) {
        var attr = agTypes.attributes.baseAsset[attrId];
        allWeatherStationAttributesKeys.push(attr);
    }
    for (attrId in agTypes.attributes.weatherStation) {
        attr = agTypes.attributes.weatherStation[attrId];
        allWeatherStationAttributesKeys.push(attr);
    }

    var weatherStationDeviceKeys = [];

    for (attrId in agTypes.attributes.weatherStationDevice) {
        attr = agTypes.attributes.weatherStationDevice[attrId];
        weatherStationDeviceKeys.push(attr);
    }

    var service = {
        saveWeatherStation: saveWeatherStation,
        copyWeatherStation: copyWeatherStation,
        copyWeatherStationDialog: copyWeatherStationDialog,
        moveWeatherStationDialog: moveWeatherStationDialog,
        getWeatherStation: getWeatherStation,
        getWeatherStationDevices: getWeatherStationDevices,
        deleteWeatherStation: deleteWeatherStation,
        deleteWeatherStationRelation: deleteWeatherStationRelation
    }

    return service;

    function saveWeatherStation(weatherStation, parentEntityId) {
        var deferred = $q.defer();
        var assign = !weatherStation.id.id;
        entityService.saveRelatedEntity(weatherStation, parentEntityId, allWeatherStationAttributesKeys).then(
            function success(weatherStation) {
                if (assign) {
                    agUserService.assignAssetToCustomer(weatherStation).then(
                        (weatherStation) => {
                            deferred.resolve(weatherStation);
                        },
                        () => {
                            deferred.reject();
                        }
                    );
                } else {
                    deferred.resolve(weatherStation);
                }
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function copyWeatherStation(weatherStation, targetEntityId) {
        var deferred = $q.defer();
        entityService.copyEntity(weatherStation, targetEntityId, allWeatherStationAttributesKeys).then(
            function success(weatherStation) {
                agUserService.assignAssetToCustomer(weatherStation).then(
                    (weatherStation) => {
                        deferred.resolve(weatherStation);
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function copyWeatherStationDialog($event, weatherStation) {
        var deferred = $q.defer();
        if ($event) {
            $event.stopPropagation();
        }
        var placeholderText = 'ag.weather-station.select-copy-target-text';
        var notFoundText = 'ag.weather-station.copy-target-not-found-text';
        var requiredText = 'ag.weather-station.copy-target-requited-text';
        var targetEntitySubtypes = [agTypes.assetType.site, agTypes.assetType.siloGroup];
        var newEntityNameText = 'ag.weather-station.new-weather-station-name';
        var newEntityNameRequiredText = 'ag.weather-station.new-weather-station-name-required';

        agUserService.getAgrologCustomer().then(
            (agCustomer) => {
                var targetRootEntityId = agCustomer.id;
                $mdDialog.show({
                    controller: CopyEntityController,
                    controllerAs: 'vm',
                    templateUrl: copyEntityTemplate,
                    parent: angular.element($document[0].body),
                    locals: {
                        placeholderText: placeholderText,
                        notFoundText: notFoundText,
                        requiredText: requiredText,
                        entity: angular.copy(weatherStation),
                        targetRootEntityId: targetRootEntityId,
                        targetEntityType: types.entityType.asset,
                        targetEntitySubtypes: targetEntitySubtypes,
                        newEntityNameText: newEntityNameText,
                        newEntityNameRequiredText: newEntityNameRequiredText
                    },
                    fullscreen: true,
                    targetEvent: $event
                }).then(function () {
                    deferred.resolve();
                }, function () {
                    deferred.reject();
                });
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function moveWeatherStationDialog($event, weatherStation, parentEntityId) {
        var deferred = $q.defer();
        if ($event) {
            $event.stopPropagation();
        }

        var placeholderText = 'ag.weather-station.select-move-target-text';
        var notFoundText = 'ag.weather-station.move-target-not-found-text';
        var requiredText = 'ag.weather-station.move-target-requited-text';
        var targetEntitySubtypes = [agTypes.assetType.site, agTypes.assetType.siloGroup];

        agUserService.getAgrologCustomer().then(
            (agCustomer) => {
                var targetRootEntityId = agCustomer.id;
                $mdDialog.show({
                    controller: MoveEntityController,
                    controllerAs: 'vm',
                    templateUrl: moveEntityTemplate,
                    parent: angular.element($document[0].body),
                    locals: {
                        placeholderText: placeholderText,
                        notFoundText: notFoundText,
                        requiredText: requiredText,
                        parentEntityId: parentEntityId,
                        entity: weatherStation,
                        targetRootEntityId: targetRootEntityId,
                        targetEntityType: types.entityType.asset,
                        targetEntitySubtypes: targetEntitySubtypes
                    },
                    fullscreen: true,
                    targetEvent: $event
                }).then(function () {
                    deferred.resolve();
                }, function () {
                    deferred.reject();
                });
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getWeatherStation(weatherStationId) {
        var deferred = $q.defer();
        entityService.getRelatedEntity(weatherStationId, allWeatherStationAttributesKeys, agTypes.assetTypeTranslatePrefix).then(
            function success(weatherStation) {
                deferred.resolve(weatherStation);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getWeatherStationDevices(weatherStationId) {
        var deferred = $q.defer();
        entityService.getRelatedEntities(weatherStationId, types.entityType.device,
            [agTypes.deviceType.weatherStation], 1,
            weatherStationDeviceKeys, agTypes.deviceTypeTranslatePrefix).then(
            function success(devices) {
                deferred.resolve(devices);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }


    function deleteWeatherStation(weatherStationId) {
        var deferred = $q.defer();
        entityService.deleteRelatedEntity(weatherStationId).then(
            function success() {
                deferred.resolve();
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function deleteWeatherStationRelation(weatherStationId, parentAssetId) {
        var deferred = $q.defer();
        entityRelationService.deleteRelation(parentAssetId.id, parentAssetId.entityType,
            agTypes.relationType.weatherStation,
            weatherStationId.id, weatherStationId.entityType).then(
            function success() {
                deferred.resolve();
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }


}
